<div class="text-center text-uppercase shock-mtm-box" >
    <div class="d-inline-block">Shock current MTM values by </div>
    <div class="d-inline-block">
        <select [ngModel]="selectedValue" (ngModelChange)="selectedValueChange($event)">
            <option value="-2">-2%</option>
            <option value="-1">-1%</option>
            <option value="0.5">0.5%</option>
            <option value="1">1%</option>
            <option value="2">2%</option>
        </select>
    </div>
</div>
